import { generateUtilityClass, generateUtilityClasses, unstable_composeClasses } from "@mui/material";
const calendarMonthName = "CalendarMonth";
const calendarMonthClasses = generateUtilityClasses(
  calendarMonthName,
  ["root", "weeksContainer"]
);
function getCalendarMonthUtilityClass(slot) {
  return generateUtilityClass(calendarMonthName, slot);
}
function useCalendarMonthUtilityClasses(props) {
  const { classes } = props;
  const slots = {
    root: ["root"],
    weeksContainer: ["weeksContainer"]
  };
  return unstable_composeClasses(slots, getCalendarMonthUtilityClass, classes);
}
export {
  calendarMonthClasses,
  calendarMonthName,
  useCalendarMonthUtilityClasses
};
//# sourceMappingURL=classes.js.map
